import { DELETE_ACCOUNT_PERMENENTLY, GET_DELETE_REQ_USERS_LIST, RECOVER_ACCOUNT } from "../../../constants";

export function getDeletedReqUsers(data) {
    return {
        type: GET_DELETE_REQ_USERS_LIST,
        data,
    };
}

export function recoverAccount(data) {
    return {
        type: RECOVER_ACCOUNT,
        data,
    };
}

export function deleteAccountPermanently(data) {
    return {
        type: DELETE_ACCOUNT_PERMENENTLY,
        data,
    };
}
